@if (summary() && summary()!.skills.length > 0) {
	<div class="summary-skills">
		@for (skill of summary()!.skills; track skill.skillCode) {
			<div class="skill-badge" [class.no-history]="!skill.hasHistory">
				<span class="skill-code">{{ skill.skillCode }}</span>
				<app-rubric-level-badge class="skill-level" [level]="skill.rubricLevelLevel"></app-rubric-level-badge>
				@if (!skill.hasHistory) {
					<span
						class="skill-no-history-badge"
						nz-tooltip
						nzTooltipTitle="No history yet for this skill — showing the default starting level."
					>
						Default
					</span>
				}
			</div>
		}
	</div>
} @else {
	<nz-typography>No current skill levels recorded for this student yet.</nz-typography>
}
